import React from 'react';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AssetResourceCategoryMenuItem } from '../../../../types';
import { countFormat } from '../../../../utils/table';

interface CategoryItemProps {
  isExpanded: boolean;
  isLoading: boolean;
  isSearching: boolean;
  menuItem: AssetResourceCategoryMenuItem;
  onToggleExpand: () => void;
}

export function CategoryItem({
  isExpanded,
  isLoading,
  isSearching,
  menuItem,
  onToggleExpand,
}: CategoryItemProps) {
  const { count, label, subitems } = menuItem;
  const hasSubItems = (subitems ?? []).length > 0;

  return (
    <ListItemButton
      data-testid="resource-category-item"
      onClick={() => hasSubItems && onToggleExpand()}
      sx={{ pr: 1.5 }}
    >
      <ListItemIcon sx={{ mr: 1 }}>
        <menuItem.icon />
      </ListItemIcon>
      <Stack alignItems="center" direction="row" flexWrap="nowrap" gap={1} width="100%">
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'nowrap',
            gap: 1,
            width: '100%',
          }}
        >
          <Typography
            sx={{
              display: 'inline-block',
              flexShrink: 0,
              fontSize: 'small',
              fontWeight: 'bold',
              maxWidth: '60%',
              whiteSpace: 'normal',
            }}
            variant="body2"
          >
            {label}
          </Typography>

          <Typography color="text.secondary" sx={{ whiteSpace: 'nowrap' }} variant="body2">
            {isLoading ? (
              <Skeleton variant="text" width={30} />
            ) : (
              <Typography color="text.secondary" component="span" variant="body2">
                {countFormat(count)}
              </Typography>
            )}
          </Typography>
        </Box>
        {hasSubItems && !isSearching && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
      </Stack>
    </ListItemButton>
  );
}
